import { Store } from '@ngxs/store';
import { CapaciteModel } from '../tool-capacite/latest/modeles/capacite.model';
import { CapaciteStepEnum } from '../tool-capacite/latest/constants/capacite-step.enum';
import { CapaciteEditStepEnum } from '../tool-capacite/latest/constants/capacite-edit-step.enum';
import {
  CalculerCapacite,
  GoToStep,
  NavigatePageAccueil,
  NavigatePageFormulaire,
  NavigatePageModification,
  NavigatePageNonEligible,
  NavigatePageResultat,
  PatchCapaciteDebugOnly
} from '../tool-capacite/latest/capacite.actions';
import { CapaciteState } from '../tool-capacite/latest/capacite.state';

export class TestAutomatiseCapacite {
  constructor(private readonly store: Store) {}

  allerEtape(etape: string) {
    if (CapaciteStepEnum[etape]) {
      this.store.dispatch(new GoToStep(CapaciteStepEnum[etape]));
      this.store.dispatch(new NavigatePageFormulaire()).toPromise();
    } else {
      console.error(`L'étape ${etape} n'existe pas`);
    }
  }

  allerPage(pageUrl: string) {
    switch (pageUrl) {
      case 'resultat':
        this.store.selectSnapshot(CapaciteState.isCompleted)
          ? this.store.dispatch(new NavigatePageResultat())
          : console.error("Impossible d'aller à la page résultat. La capacité n'est pas complétée");
        break;
      case 'non-eligible':
        this.store.dispatch(new GoToStep(1));
        this.store.dispatch(new NavigatePageNonEligible());
        break;
      case 'accueil':
        this.store.selectSnapshot(CapaciteState.isCompleted)
          ? console.error("Impossible d'aller à la page d'accueil. La capacité est déjà complétée")
          : this.store.dispatch(new NavigatePageAccueil());
        break;
      default:
        console.error('Page invalide');
    }
  }

  allerPageModification(etape: string) {
    if (CapaciteEditStepEnum[etape]) {
      this.store.dispatch(new NavigatePageModification(CapaciteEditStepEnum[etape]));
    } else {
      console.error(`L'étape de modification ${etape} n'existe pas`);
    }
  }

  chargerDonnees(data: Partial<CapaciteModel>) {
    this.store.dispatch(new PatchCapaciteDebugOnly(data, false));
  }

  setupBackend(data: Partial<CapaciteModel>) {
    this.store.dispatch(new CalculerCapacite(data));
  }
}
